import { BRAND } from "@/data/content";

// Single source of truth for the official IIUTC Study WhatsApp number.
// wa.me links require digits only (no "+", spaces, or dashes).
export const WHATSAPP_NUMBER = String(BRAND.whatsapp || "").replace(/\D/g, "");

export const DEFAULT_WHATSAPP_MESSAGE =
  "Hello IIUTC Study,\nI would like to know more about studying abroad.\nPlease contact me.";

/**
 * Builds a wa.me deep link with a properly URL-encoded message.
 */
export function buildWhatsAppUrl(message = DEFAULT_WHATSAPP_MESSAGE) {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}

/**
 * Opens WhatsApp (web/app) in a new browser tab with the given message.
 */
export function openWhatsApp(message = DEFAULT_WHATSAPP_MESSAGE) {
  const url = buildWhatsAppUrl(message);
  window.open(url, "_blank", "noopener,noreferrer");
  return url;
}

/**
 * Formats a structured student enquiry (from the contact form or the
 * popup form) into the WhatsApp message described in the product spec.
 */
export function buildEnquiryMessage({ name, phone, email, course, message } = {}) {
  const line = (v) => (v && String(v).trim() ? String(v).trim() : "-");
  return [
    "Hello IIUTC Study,",
    "New Student Enquiry",
    `Name: ${line(name)}`,
    `Mobile Number: ${line(phone)}`,
    `Email: ${line(email)}`,
    `Course Interested In: ${line(course)}`,
    `Message: ${line(message)}`,
    "Please contact me.",
  ].join("\n");
}
